"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShapeToBorderRadiusSize = useShapeToBorderRadiusSize;
var _borderRadius = require("../tokens/borderRadius");
var _useShapeToBorderRadiusAlias = require("./useShapeToBorderRadiusAlias");
function useShapeToBorderRadiusSize(shape) {
  const borderRadius = (0, _useShapeToBorderRadiusAlias.useShapeToBorderRadiusAlias)(shape);
  return borderRadius ? _borderRadius.borderRadius[borderRadius] : 0;
}